module.exports = __webpack_public_path__ + "3abcfe1f16d26e79ab85a2d3b4b74e09.svg";